import { Link } from 'react-router-dom';

const ENTRIES = [
  {
    to: '/category/movie',
    icon: 'ri-film-line',
    title: '电影',
    desc: '科幻 · 悬疑 · 剧情 · 动作',
    count: '12 部',
  },
  {
    to: '/category/tv',
    icon: 'ri-live-line',
    title: '电视剧',
    desc: '古装 · 都市 · 刑侦 · 治愈',
    count: '9 部',
  },
  {
    to: '/category/hot',
    icon: 'ri-fire-line',
    title: '热门推荐',
    desc: '按热度与口碑精选',
    count: '每日更新',
  },
];

export default function CategoryQuickLinks() {
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      {ENTRIES.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 hover:bg-primary-50/60 cursor-pointer"
        >
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-600 text-background-50 transition-colors group-hover:bg-accent-500">
            <i className={`${item.icon} text-2xl`} />
          </span>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
              <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-800">
                {item.count}
              </span>
            </div>
            <p className="mt-0.5 truncate text-xs text-foreground-500">{item.desc}</p>
          </div>
          <i className="ri-arrow-right-s-line text-xl text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500" />
        </Link>
      ))}
    </div>
  );
}